<div id="login" fusePerfectScrollbar class="fx-column">
  <div id="login-form-wrapper" class="fx-column fx-justify-center fx-items-center">
    <div class="form-wrapper">

      <div class="logo mb-32">
        <img src="assets/images/logos/tangerine_logo.png" />
      </div>

      <div
        id="login-form"
        *fuseIfOnDom
				[@animate]="{
					value: '*',
					params: { duration: '300ms', y: '100px' }
				}"
        >
        <div class="title">{{ 'RESET_PASSWORD.TITLE' | translate }}</div>

        @if (saving) {
          <mat-progress-bar
            class="mt-24 mb-24"
            style="min-width:300px"
            mode="indeterminate"
          ></mat-progress-bar>
        }

        @if (invalidLink) {
          <p class="red-fg">
            {{ 'RESET_PASSWORD.ERROR.INVALID_LINK' | translate }}
          </p>
        } @else {
          <form name="resetForm" [formGroup]="resetForm" novalidate>
            <mat-form-field appearance="fill">
              <mat-label>{{ 'RESET_PASSWORD.PASSWORD' | translate }}</mat-label>
              <input
                matInput
                type="password"
                formControlName="password"
                />
              <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
              @if (resetFormErrors.password.required) {
                <mat-error
                  >
                  {{ 'RESET_PASSWORD.ERROR.PASSWORD_REQUIRED' | translate }}
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>{{ 'RESET_PASSWORD.PASSWORD_CONFIRMATION' | translate }}</mat-label>
              <input
                matInput
                type="password"
                formControlName="password_confirmation"
                />
              <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
              @if (resetFormErrors.password_confirmation.required) {
                <mat-error
                  >
                  {{ 'RESET_PASSWORD.ERROR.PASSWORD_REQUIRED' | translate }}
                </mat-error>
              }
            </mat-form-field>

            @if (resetForm.hasError('passwordsMismatch')) {
              <p class="red-fg">
                {{ 'RESET_PASSWORD.ERROR.PASSWORD_MISMATCH' | translate }}
              </p>
            }

            @if (lastErrorMessage) {
              <p class="red-fg">
                {{ lastErrorMessage }}
              </p>
            }

            <button
              mat-flat-button
              (click)="onSubmitClick()"
              color="accent"
              class="submit-button"
              [disabled]="resetForm.invalid || saving"
              >
              <span>{{ 'RESET_PASSWORD.SAVE' | translate }}</span>
            </button>
          </form>
        }

        <a
          class="login-link"
          [routerLink]="'/auth/login'"
          >
          {{ 'RESET_PASSWORD.BACK_TO_LOGIN' | translate }}
        </a>

      </div>
    </div>
  </div>
</div>
